import { Feature as VdsFeature, FeatureProps } from "@vds/typography";

const Feature = ({ children, ...rest }: FeatureProps) => {
  return <VdsFeature {...rest}>{children}</VdsFeature>;
};

export default Feature;
